import React, { useMemo } from 'react'
import { SUPPORTED_LANGS, createFastContext } from '@rst/libs-ts'
import { ReactNode } from 'react'
import styled, { ThemeProvider } from 'styled-components'

const { useCtx: useL10nCtx, Provider } = createFastContext({
	lang: 'ru',
	rtl: false,
	availableLangs: ['ru'],
})

const L10nCtxProvider = ({
	lang,
	availableLangs,
	children,
}: {
	lang: string
	availableLangs: string[]
	children?: ReactNode
}) => {
	const rtl = useMemo(() => !!SUPPORTED_LANGS[lang]?.props?.rtl, [lang])

	return (
		<Provider value={{ lang, rtl, availableLangs }}>
			<ThemeProvider theme={{ rtl }}>
				<LangStyles rtl={rtl}>{children}</LangStyles>
			</ThemeProvider>
		</Provider>
	)
}

export const DisableL10N = ({ children }: { children: ReactNode }) => {
	return (
		<Provider value={{ lang: 'ru', rtl: false, availableLangs: ['ru'] }}>
			<ThemeProvider theme={{ rtl: false }}>
				<LangStyles>{children}</LangStyles>
			</ThemeProvider>
		</Provider>
	)
}

const LangStyles = styled.div<{ rtl?: boolean }>`
	& span,
	& p,
	& h1,
	& h2,
	& h3,
	& h4,
	& h5,
	& h6,
	& input,
	& textarea,
	& label,
	& a {
		direction: ${({ rtl }) => (rtl ? 'rtl' : 'ltr')};
	}
	/* .fake-input {
		direction: ltr;
	} */
	& a[href^='tel:'] {
		direction: ltr;
		text-align: ${({ rtl }) => (rtl ? 'right' : 'left')};
	}
`

export { useL10nCtx, L10nCtxProvider }
